<template>
  <div class="m-column-filters">
    <b-modal id="column_filters_string" v-model="string.active" centered hide-footer hide-header>
      <svg
        class="m-column-filters__close__modal"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="string.active = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="string.condition"
            class="m-column-filters__condition"
            size="small"
            type="select"
            :items="string.conditions"
          />
        </div>

        <div class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model="string.value"
            class="m-column-filters__value m-column-filters__value_string"
            placeholder-style="italic"
            placeholder="Введите не менее 3 символов"
            size="small"
            :input-text-condition="string.errorMessage"
          />
        </div>

        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="setFilter"
          />

          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="removeFilter"
          />

          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="removeFilter" />

          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="setFilter" />
        </div>
      </div>
    </b-modal>

    <b-modal
      id="column_filters_number"
      v-model="number.active"
      :size="getModalNumberSize(number.condition.value)"
      centered
      hide-footer
      hide-header
    >
      <svg
        class="m-column-filters__close__modal"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="number.active = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="number.condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="number.conditions"
          />
        </div>

        <div v-if="number.condition.value !== '4'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model.number="number.value"
            class="m-column-filters__value m-column-filters__value_string m-column-filters__value_string_width_45"
            :type="'number'"
            placeholder="0"
            size="small"
          />
        </div>

        <div class="m-column-filters__range">
          <div v-if="number.condition.value === '4'" class="m-column-filters__item m-column-filters__item_value">
            <c-input
              v-model="number.rangeValue.start"
              class="m-column-filters__value m-column-filters__value_string"
              :type="'number'"
              :required-message="number.errorMessage"
              placeholder="0"
              size="small"
            />
          </div>

          <div v-if="number.condition.value === '4'" class="m-column-filters__item-sep">-</div>

          <div v-if="number.condition.value === '4'" class="m-column-filters__item m-column-filters__item_value">
            <c-input
              v-model="number.rangeValue.end"
              class="m-column-filters__value m-column-filters__value_string"
              :type="'number'"
              :required-message="number.errorMessage"
              placeholder="0"
              size="small"
            />
          </div>

          <div v-if="number.errorMessage && number.condition.value === '4'" class="m-column-filters__range__warning">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
              <circle cx="7" cy="10" r="1" fill="#FF238D" />
              <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
            </svg>
            <div class="m-column-filters__range__warning__text">{{ number.errorMessage }}</div>
          </div>
        </div>
        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            :tooltip="'Применить фильтр по столбцу'"
            @click="setFilter"
          />

          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="removeFilter"
          />

          <c-button class="m-column-filters__action_mobile" label="Сбросить" color="white" @click="removeFilter" />

          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="setFilter" />
        </div>
      </div>
    </b-modal>

    <b-modal
      id="column_filters_date"
      v-model="date.active"
      :size="getModalDateSize(date.condition.value)"
      centered
      hide-footer
      hide-header
    >
      <svg
        class="m-column-filters__close__modal"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="date.active = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="date.condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="date.conditions"
          />
        </div>

        <div v-if="date.condition.value !== 'range'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            ref="dateValueInput"
            v-model="date.value"
            class="m-column-filters__value m-column-filters__value_string"
            size="small"
            icon="calendar"
            :icon-right="true"
            type="date"
            :editable="true"
            :class="{
              'm-column-filters-date-required': date.errorMessage,
            }"
            :required="date.errorMessage"
            @date-validity-check="dateValidityCheck"
          />
        </div>

        <div v-if="date.condition.value === 'range'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            ref="dateRangeStart"
            v-model="date.rangeValue.start"
            class="m-column-filters__value m-column-filters__value_string"
            size="small"
            icon="calendar"
            :icon-right="true"
            type="date"
            :editable="true"
            :class="{
              'm-column-filters-date-required': date.errorMessageStartRange,
            }"
            :required="date.errorMessageStartRange"
            @invalid-date="date.errorMessageStartRange = 'Неверно указана дата'"
          />
        </div>

        <div v-if="date.condition.value === 'range'" class="m-column-filters__item-sep">-</div>

        <div v-if="date.condition.value === 'range'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            ref="dateRangeEnd"
            v-model="date.rangeValue.end"
            class="m-column-filters__value m-column-filters__value_string"
            size="small"
            icon="calendar"
            :icon-right="true"
            type="date"
            :editable="true"
            :class="{
              'm-column-filters-date-required': date.errorMessageEndRange,
            }"
            :required="date.errorMessageEndRange"
            @invalid-date="date.errorMessageEndRange = 'Неверно указана дата'"
          />
        </div>

        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="setFilter"
          />

          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="removeFilter"
          />

          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="removeFilter" />

          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="setFilter" />
        </div>
      </div>
    </b-modal>

    <b-modal id="column_filters_reference" v-model="list.active" size="reference" centered hide-footer hide-header>
      <svg
        class="m-column-filters__close__modal"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="list.active = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="list.condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="list.conditions"
          />
        </div>

        <div class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model="list.value"
            class="m-column-filters__value m-column-filters__value_select"
            type="select"
            size="small"
            placeholder="Выберите значение"
            :items="referenceList"
            :multiple="true"
            :searchable="true"
            :class="{
              'm-column-filters-date-required': list.errorMessage,
            }"
            :style="{
              'margin-bottom': list.errorMessage ? '20px' : '',
            }"
            :required="list.errorMessage"
            :input-text-condition="list.errorMessage"
          />
        </div>

        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="setFilter"
          />

          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="removeFilter"
          />

          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="removeFilter" />

          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="setFilter" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";

export default {
  name: "m-column-filters",

  components: {
    "c-button": Button,
    "c-input": Input,
  },

  props: ["column", "referenceList", "activeFilters"],

  data() {
    return {
      string: {
        errorMessage: "",
        active: this.column && this.column.type === "string",
        conditions: [
          { label: "Поиск по подстроке", value: "2" },
          { label: "Точное совпадение", value: "1" },
        ],
        condition: { label: "Поиск по подстроке", value: "2" },
        value: "",
      },

      number: {
        errorMessage: "Укажите диапазон",
        active: this.column && this.column.type === "number",
        conditions: [
          { label: "Меньше", value: "1" },
          { label: "Больше", value: "2" },
          { label: "Равно", value: "3" },
          { label: "Диапазон", value: "4" },
        ],
        condition: { label: "Меньше", value: "1" },
        value: "",
        rangeValue: {
          start: "",
          end: "",
        },
      },

      date: {
        active: this.column && this.column.type === "date",
        conditions: [
          { label: "Дата", value: "date" },
          { label: "До", value: "before" },
          { label: "После", value: "after" },
          { label: "Период", value: "range" },
        ],
        condition: { label: "Дата", value: "date" },
        value: "",
        rangeValue: {
          start: "",
          end: "",
        },
        errorMessage: "",
        errorMessageStartRange: "",
        errorMessageEndRange: "",
        valid: true,
      },

      list: {
        active: this.column && this.column.type === "list",
        conditions: [
          { label: "Выбрать значения", value: "1" },
          { label: "Все, кроме", value: "2" },
        ],
        condition: { label: "Выбрать значения", value: "1" },
        value: [],
        reference: [],
        errorMessage: "",
      },
      firstLoad: true,
    };
  },

  watch: {
    "column": function (value) {
      this.string.active = false;
      this.number.active = false;
      this.date.active = false;
      this.list.active = false;

      if (value) {
        if (value.type === "string") this.string.active = true;
        if (value.type === "number") this.number.active = true;
        if (value.type === "date") this.date.active = true;
        if (value.type === "list") {
          this.$emit("getReferenceValues", this.column);
          this.list.active = true;
        }
      }
    },

    // "activeFilters": function(value) {
    //   console.log(value)
    // },

    "string.active": function (value) {
      if (value) {
        this.string.errorMessage = "";
        const c = this.activeFilters.findIndex((i) => i.id === this.column.id);

        if (c !== -1) {
          const conditionIndex = this.string.conditions.findIndex((i) => i.value === this.activeFilters[c].searchType);
          this.string.value = this.activeFilters[c].value;
          this.string.condition = this.string.conditions[conditionIndex];
        } else {
          this.string.value = "";
          this.string.condition = { label: "Поиск по подстроке", value: "2" };
        }
      }

      if (!value && !this.number.active && !this.list.active && !this.date.active) this.$emit("close");
    },

    "number.active": function (value) {
      if (value) {
        this.number.errorMessage = "";
        const c = this.activeFilters.findIndex((i) => i.id === this.column.id);
        if (c !== -1 && this.activeFilters[c].searchType === "4") {
          this.number.rangeValue.start = this.activeFilters[c].value.start;
          this.number.rangeValue.end = this.activeFilters[c].value.end;
          this.number.condition = { label: "Диапазон", value: "4" };
        } else if (c !== -1) {
          const conditionIndex = this.number.conditions.findIndex((i) => i.value === this.activeFilters[c].searchType);
          this.number.value = this.activeFilters[c].value;
          this.number.condition = this.number.conditions[conditionIndex];
        } else {
          this.number.value = "";
          this.number.condition = { label: "Меньше", value: "1" };
        }
      }

      if (!value && !this.string.active && !this.list.active && !this.date.active) this.$emit("close");
    },

    "list.active": function (value) {
      if (value) {
        const c = this.activeFilters.findIndex((i) => i.id === this.column.id);
        if (c !== -1) {
          const conditionIndex = this.number.conditions.findIndex((i) => i.value === this.activeFilters[c].searchType);
          this.list.value = [...this.activeFilters[c].value];
          this.list.condition = this.list.conditions[conditionIndex];
        } else {
          this.list.value = [];
          this.list.condition = { label: "Выбрать значения", value: "1" };
        }
      }

      if (!value && !this.number.active && !this.string.active && !this.date.active) this.$emit("close");
    },

    "date.active": function (value) {
      if (!value && !this.number.active && !this.list.active && !this.string.active) {
        this.$emit("close");
      }

      if (!value) {
        return;
      }

      const activeIndex = this.activeFilters.findIndex((item) => item.id === this.column.id);

      if (activeIndex !== -1) {
        this.date.condition = this.date.conditions.find(
          (item) => item.value === this.activeFilters[activeIndex].searchType,
        );
        if (this.date.condition.value === "range") {
          const [startDate, endDate] = this.activeFilters[activeIndex].value.split(",");
          this.date.rangeValue.start = startDate;
          this.date.rangeValue.end = endDate;
          return;
        }
        this.date.value = this.activeFilters[activeIndex].value;
      }
      this.firstLoad = false;
    },

    "date.condition": function (newValue, oldValue) {
      if (oldValue && oldValue.value === "range") {
        setTimeout(() => {
          this.$refs.dateValueInput.clear();
        }, 0);
        return;
      }
      if (newValue && newValue.value === "range" && !this.firstLoad) {
        setTimeout(() => {
          this.$refs.dateRangeEnd.clear();
          this.$refs.dateRangeStart.clear();
        }, 0);
      }
    },

    "number.rangeValue": {
      deep: true,
      handler(value) {
        if (value.end && value.start && Number(value.end) >= Number(value.start)) {
          this[this.column.type].errorMessage = "";
        }
      },
    },

    "date.value": {
      deep: true,
      handler(value) {
        if (value) {
          this[this.column.type].errorMessage = "";
        }
      },
    },

    "date.rangeValue": {
      deep: true,
      handler(value) {
        if (value.start) {
          this[this.column.type].errorMessageStartRange = "";
        }
        if (value.end) {
          this[this.column.type].errorMessageEndRange = "";
        }
      },
    },

    "list.value": {
      deep: true,
      handler(value) {
        if (value.length) {
          this[this.column.type].errorMessage = "";
        }
      },
    },

    "referenceList": function (reference) {
      this.list.value = this.list.value.map((i) => {
        if (!i.label) {
          const c = reference.findIndex((item) => item.id.toString() === i.id.toString());
          if (c !== -1) return { id: i.id, value: i.id, label: reference[c].label };
        }
        return i;
      });
    },
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.setFilter();
      }
    });
  },

  methods: {
    dateValidityCheck(value) {
      this.date.valid = value
    },
    getModalNumberSize(value) {
      if (value !== "4") {
        return "number";
      }
      return "";
    },

    getModalDateSize(value) {
      if (value === "range") {
        return "date-range";
      }
      return "date";
    },

    setFilter() {
      if (this.column !== null) {
        if (
          this.column.type === "string" &&
          this[this.column.type].value.length < 1 &&
          this[this.column.type].value.length > 0
        ) {
          this[this.column.type].errorMessage = "Введите не менее 1-го символа";
          return;
        }

        if (
          this.column.type === "number" &&
          this[this.column.type].condition.value === "4" &&
          ((this[this.column.type].rangeValue.start === "" && this[this.column.type].rangeValue.end) ||
            (this[this.column.type].rangeValue.start &&
              !this[this.column.type].rangeValue.end &&
              this[this.column.type].rangeValue.end === ""))
        ) {
          this[this.column.type].errorMessage = "Укажите диапазон";
          return;
        }

        if (
          this.column.type === "number" &&
          this[this.column.type].condition.value === "4" &&
          this[this.column.type].rangeValue.start > this[this.column.type].rangeValue.end
        ) {
          this[this.column.type].errorMessage = "Укажите корректный диапазон";
          return;
        }

        if (this.column.type === "date") {
          if (this[this.column.type].condition.value !== "range" && !this[this.column.type].value) {
            this[this.column.type].errorMessage = "Укажите дату";
            return;
          }

          if (!this.date.valid) return

          let isRangeInvalid = false;
          if (this[this.column.type].condition.value === "range" && !this[this.column.type].rangeValue.start) {
            this[this.column.type].errorMessageStartRange = "Укажите начальную дату";
            isRangeInvalid = true;
          }
          if (this[this.column.type].condition.value === "range" && !this[this.column.type].rangeValue.end) {
            this[this.column.type].errorMessageEndRange = "Укажите конечную дату";
            isRangeInvalid = true;
          }

          if (isRangeInvalid) {
            return;
          }
        }

        if (this.column.type === "list" && !this[this.column.type].value.length) {
          //this[this.column.type].errorMessage = "Обязательное поле";
          //  return;
        }

        this[this.column.type].active = false;

        this.$emit("setFilter", {
          id: this.column.id,
          filter: this[this.column.type],
          type: this.column.type,
        });
      }
    },

    removeFilter() {
      this[this.column.type].active = false;

      this.resetFilters();

      this.$emit("removeFilter", this.column.id);
    },

    resetFilters() {
      this.string.errorMessage = "";
      this.string.value = "";
      this.string.condition = { label: "Поиск по подстроке", value: "2" };

      this.number.errorMessage = "";
      this.number.value = "";
      this.number.condition = { label: "Меньше", value: "1" };
      this.number.rangeValue.start = "";
      this.number.rangeValue.end = "";

      this.date.value = "";
      this.date.condition = { label: "Дата", value: "1" };
      this.date.rangeValue.start = "";
      this.date.rangeValue.end = "";

      this.list.value = [];
      this.list.condition = { label: "Выбрать значения 3", value: "1" };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-column-filters {
  &__wrapper {
    display: flex;
    justify-content: space-between;
    margin: 25px -2px -2px;
  }

  &__condition {
    width: 150px;
    margin-right: 20px;

    & ::v-deep .c-input-value_size_small {
      padding-top: 5px;
    }

    & ::v-deep .c-input-value_type_select {
      max-width: calc(100% - 20px);
    }
  }

  &__actions {
    display: inline-flex;
    margin-left: 20px;
  }

  &__action {
    &:first-child {
      margin-right: 10px;
    }

    &_mobile {
      display: none;
    }
  }

  &__item {
    &_value {
      flex-grow: 1;
    }

    &-sep {
      margin: 6px 20px 0;
      color: $color-label;
    }
  }

  &__value {
    &_string {
      @media (max-width: 700px) {
        &_width_45 {
          width: 42%;
        }
      }
    }
    &_select {
      & ::v-deep .c-input {
        width: 217px;

        @media screen and (max-width: 700px) {
          width: 100%;
        }
      }
    }
  }

  &__close__modal {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 8px;
  }

  &__range {
    position: relative;
    display: flex;

    &__warning {
      display: flex;
      position: absolute;
      left: 0;
      bottom: -20px;
      align-items: center;
      visibility: visible;
      opacity: 1;
      transition: 0.2s;

      &__text {
        white-space: nowrap;
        font-size: 11px;
        color: $color-secondary;
        margin-left: 10px;
        margin-top: 1px;
      }
    }
  }

  @media screen and (max-width: 700px) {
    &__wrapper {
      flex-direction: column;
      margin: 40px 0 0 0;
    }

    &__condition {
      width: auto;
      margin-right: 0;
      margin-bottom: 20px;
    }

    &__actions {
      margin-left: -20px;
      margin-right: -20px;
      margin-top: 38px;
    }

    &__action {
      display: none;

      &_mobile {
        display: block;
        border-radius: 0;
        width: 50%;
      }
    }
  }
}

::v-deep .modal-reference {
  max-width: 533px !important;
}

::v-deep .modal-number {
  max-width: 420px !important;
}

::v-deep .modal-date {
  max-width: 420px !important;
}

::v-deep .modal-date-range {
  max-width: 700px !important;
}

::v-deep .modal {
  font-family: Fira Sans, sans-serif;
}

::v-deep .c-select__search {
  padding: 5px 0 !important;
}
::v-deep .modal#column_filters_date .modal-body {
  overflow: visible;
}
</style>
